// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"59":"84bea6754ae3f43a7891","524":"4cd8dff481c97b8de226"}[chunkId] + ".css";
};